"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../useIsomorphicLayoutEffect"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useEventListener = function useEventListener(eventName, handler, target, options) {
  var savedHandler = (0, _react.useRef)(handler);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    savedHandler.current = handler;
  }, [handler]);
  (0, _react.useEffect)(function () {
    var targetElement = target !== null && target !== void 0 ? target : window;
    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) return;
    targetElement.addEventListener(eventName, handler, options);
    return function () {
      targetElement.removeEventListener(eventName, handler, options);
    };
  }, [handler, eventName, target, options]);
};
var _default = useEventListener;
exports.default = _default;